import {ModelClass} from "../../ModelClass";

/**
 * 스케쥴 별 내역
 */
export class ScheduleRevenueItem extends ModelClass {
    constructor(revenueItem) {
        super(revenueItem);
        this.revenueMonth = 0; //분배월
        this.calculateMonth = 0;//정산월
        this.scheduleDate = null;//스케쥴 일시
        this.assetType = null; // 카탈로그 구분
        this.scheduleCode = null; // 스케쥴 코드
        this.name = null;// 스케쥴 명
        this.artist = null; // 아티스트
        this.sumMoneySale = 0; // 판매액 (매출)
        this.sumMoneyFee = 0; // 수수료
        this.sumMoneyOffset = 0; // 상계 대상 금액
        this.sumMoneyRevenue = 0; // 지급 대상 금액
        this.init(revenueItem);
    }

    init(revenueItem) {
        Object.keys(this).forEach(keyName => {
            switch (keyName) {
                case 'revenueMonth':
                case 'calculateMonth':
                    if (revenueItem?.[keyName]) {
                        this[keyName] = this.getYearMonthStr(revenueItem[keyName], this.fmt_yyyyMM_dot);
                    }
                    break;

                case 'scheduleDate':
                    this[keyName] = this.getDateToStr(revenueItem[keyName]);
                    break;

                case 'sumMoneySale':
                case 'sumMoneyFee':
                case 'sumMoneyOffset':
				case 'sumMoneyRevenue':
                    this[keyName] = this.getNumberWithDecimaPoint(revenueItem?.[keyName], 2);
                    break;

                default:
                    if (revenueItem?.[keyName]) {
                        this[keyName] = revenueItem[keyName];
                    }
                    break;
            }
        });
    }
}